module.exports = "/images/vendor/desiigner-svg/svg/places/university.svg?6c11b7ee58cbf32ab5b4bf8e15468653";